// @ts-nocheck

import { SportIds, type SportId } from '../../../../types/sports';

import { default as LineUpBasketBackground } from './line_up_basket_background.png';
import { default as LineUpBasketField } from './line_up_basket_field.png';
import { default as LineUpIceHockeyBackground } from './line_up_icehockey_background.png';
import { default as LineUpIceHockeyField } from './line_up_icehockey_field.png';
import { default as LineUpRugbyBackground } from './line_up_rugby_background.png';
import { default as LineUpRugbyField } from './line_up_rugby_field.png';
import { default as LineUpSoccerBackground } from './line_up_soccer_background.png';
import { default as LineUpSoccerField } from './line_up_soccer_field.png';
export { default as LineUpFormula1StartingTrack } from './line_up_formula_1_starting_track.jpg';
export { default as LineUpFormula1TrackRepeat } from './line_up_formula_1_track_repeat.jpg';

export const LineUpBackgroundsBySportId: Record<SportId, string> = {
  [SportIds.SOCCER]: LineUpSoccerBackground,
  [SportIds.RUGBY]: LineUpRugbyBackground,
  [SportIds.RUGBY_LEAGUE]: LineUpRugbyBackground,
  [SportIds.BASKETBALL]: LineUpBasketBackground,
  [SportIds.ICEHOCKEY]: LineUpIceHockeyBackground,
  [SportIds.FORMULA_1]: '',
};

export const LineUpFieldsBySportId: Record<SportId, string> = {
  [SportIds.SOCCER]: LineUpSoccerField,
  [SportIds.RUGBY]: LineUpRugbyField,
  [SportIds.RUGBY_LEAGUE]: LineUpRugbyField,
  [SportIds.BASKETBALL]: LineUpBasketField,
  [SportIds.ICEHOCKEY]: LineUpIceHockeyField,
  [SportIds.FORMULA_1]: '',
};
